var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('audio',{ref:"tada",attrs:{"src":"/sounds/success.m4a","type":"audio/x-m4a"}}),_c('audio',{ref:"tada2",attrs:{"src":"/sounds/tada2.flac","type":"audio/x-m4a"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }